import { useState, useEffect } from 'react';
import { appointmentsAPI } from '../utils/api';

const useAppointmentStatus = (candidateEmail) => {
  const [appointmentStatus, setAppointmentStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!candidateEmail) {
      setAppointmentStatus(null);
      setLoading(false);
      return;
    }

    const checkAppointmentStatus = async () => {
      try {
        setLoading(true);
        const response = await appointmentsAPI.checkStatus({ email: candidateEmail });
        setAppointmentStatus(response.data);
      } catch (error) {
        console.error('Error checking appointment status:', error);
        setAppointmentStatus(null);
      } finally {
        setLoading(false);
      }
    };

    checkAppointmentStatus();
  }, [candidateEmail]);

  return { appointmentStatus, loading };
};

export default useAppointmentStatus;
